import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import NavBar from '../../components/NavBar';
import visitsAPI from '../../services/api/visits';
import { VisitsQuestionnaireDto } from '../../types/visits';
import { StyledContainer } from './VisitQuestionnaire.style';
import VisitQuestionnaireInputs from './VisitQuestionnaireInputs';

const VisitQuestionnaire = (): JSX.Element | null => {
  const { visitId } = useParams();
  const [visitsQuestionnaire, setVisitsQuestionnaire] = useState<
    VisitsQuestionnaireDto | undefined
  >();
  const getVisitsQuestionnaire = async () => {
    const visitsQuest = await visitsAPI.getVisitsQuestionnaire(
      visitId as string,
    );
    setVisitsQuestionnaire(visitsQuest);
  };
  useEffect(() => {
    if (visitId) {
      getVisitsQuestionnaire();
    }
  }, [visitId]);
  return (
    <StyledContainer>
      <NavBar />
      {visitsQuestionnaire && (
        <VisitQuestionnaireInputs
          visitsQuestionnaire={visitsQuestionnaire}
          visit_id={visitId ?? ''}
        />
      )}
    </StyledContainer>
  );
};
export default VisitQuestionnaire;
